<template>
  <div class="container-fluid position-relative row vh-100 m-0 p-0 wow fadeIn">
    <!-- منوی سمت راست -->
    <right-Menu></right-Menu>
    <div class="col p-3 vh-100 overflow-scroll pr-95px">
      <!-- استفاده از ایندکس در کار مودال اختلال ایجاد می کند -->
      <!-- style="z-index: 0;" -->
      <!-- مرکز صفحه -->
      <tab-header
        v-if="checkShowComponent"
        v-bind:tabActiveInParent="tabActive"
      ></tab-header>
      <tab-body
        v-if="checkShowComponent"
        v-bind:tabActive="tabActive.tabID"
      ></tab-body>
    </div>
  </div>
</template>

<script>
import RightMenu from "./Components/RightMenu/RightMenu.vue";
import TabHeader from "./Components/TabHeader/TabHeader.vue";
import TabBody from "./Components/TabBody/TabBody.vue";
import { newRoutes } from "../../main";
import { BusEvent } from "../../main.js";
import swal from "sweetalert";
// import { timeout } from "q";

export default {
  data() {
    return {
      // به تب هدر پاس داده می شود تا مقدار تب فعال را دریافت نماید
      tabActive: {
        tabID: 1,
      },
      // کنترل زمان نمایش کامپاننت ها
      checkShowComponent: false,
      // کنترل مدت زمان عدم استفاده کاربر از میزکار
      timeout: null, // مربوط به setTimeout : کنترل پایان مدت میزکار
      showDialogInterVal: null, // مربوط به setInterval : کنترل نمایش پنجره هشدار
    };
  },
  components: {
    rightMenu: RightMenu,
    tabHeader: TabHeader,
    tabBody: TabBody,
  },
  computed: {},
  methods: {
    // این تابع توسط دکمه متوجه شدم از هشدارهای مدیر فراخوانی می شود
    async AllowAlertAdmin(alertID){
      // ارسال مقدار به سرور و درج در سوابق کاربر جاری
      await this.$store.dispatch("setAllowAlertAdmin", {alertID});
    },
    // این تابع مدت زمان عدم فعالیت کاربر در میزکار را بررسی می کند
    // اگر عدم فعالیت کاربر از مدت زمان تعیین شده بیشتر شود
    // کادر هشداری با 30 ثانیه مهلت تایید به وی نمایش داده می شود
    // در صورت عدم تایید در مهلت تعیین شده کاربر به صفحه ورود هدایت می شود
    CheckTimeOutDashboard() {
      // حذف شمارنده قدیمی و ایجاد یک شمارنده جدید
      // این کار با هربار کلیک کاربر تکرار می شود
      // و از آخرین کلیک کاربر باید 15 دقیقه گذشته باشد تا پنجره پیام نمایش داده شود
      clearTimeout(this.timeout);
      clearInterval(this.showDialogInterVal);

      // console.log('Refresh');

      // دریافت تنظیمات نرم افزار از مخزن اصلی
      let settingWebApp = this.$store.getters.getSettingWebApp;
      // دریافت مدت زمان مجاز عدم فعالیت کاربر از مخزن اصلی
      let LogOutDashboardTime = settingWebApp.LogOutDashboardTime;
      // مدت زمان نمایش پیام بسته شدن میزکار به کاربر
      let TimeShowLogOutDialogue = settingWebApp.TimeShowLogOutDialogue;

      this.timeout = setTimeout(() => {
        // شمارش معکوس خروج از میزکار - اجرا هر یک ثانیه یکبار
        let CounterCloseSwal = TimeShowLogOutDialogue;
        this.showDialogInterVal = setInterval(
          () => {
            // شمارش معکوس
            CounterCloseSwal--;
            // console.log(CounterCloseSwal);
            // تغییر متن دکمه کادر پیام
            $(".swal-button--ok").html(
              "مایل به ادامه فعالیت می باشم ( " + CounterCloseSwal + " )"
            );
          },
          1000,
          CounterCloseSwal
        );

        swal({
          title: "پایان مدت استفاده از میزکار",
          text:
            "به مدت " +
            LogOutDashboardTime +
            " دقیقه هست که با میزکار خود کار نکرده اید !\n" +
            "تا " +
            TimeShowLogOutDialogue +
            " ثانیه دیگر از میزکار خارج خواهید شد .",
          icon: "error", // success, warning, error, info
          buttons: {
            ok: "مایل به ادامه فعالیت می باشم ( " + CounterCloseSwal + " )",
          },
          timer: TimeShowLogOutDialogue * 1000, // بعد از 30 ثانیه خودکار بسته شود
          closeOnEsc: false, // با دکمه Esc بسته نشود
          closeOnClickOutside: false, // با کلیک در خارج از کادر پیام بسته نشود
        }).then(async (value) => {
          if (value) {
            // ادامه کار در میزکار
            // کاربر دکمه (مایل به ادامه فعالیت هستم) را کلیک کرده است
            this.CheckTimeOutDashboard();
          } else {
            // خروج از نرم افزار
            clearTimeout(this.timeout);
            clearInterval(this.showDialogInterVal);

            // حذف کوکی نگهدارنده توکن
            let token = await this.$store.getters.getUserData.token;
            await this.$store.dispatch("removeAutuCookie", { token });
            // تخلیه اطلاعات اسناد موقت هنگام خروج
            // await this.$store.commit("setTbTmpDocDataEmptyInLogOut");
            // خروج
            newRoutes.push("Login");
          }
        });
      }, LogOutDashboardTime * 60 * 1000);
    },
    // تنظیم وضعیت نمایش کامپاننت ها
    setShowComponents(show) {
      this.checkShowComponent = show;
    },
    onClick: function (event) {
      if (event.target.className.toString().includes("MainMenu") == false) {
        // فراخوانی رویداد بستن منوی کشویی بازشونده
        BusEvent.$emit("CloseMainMenu");
      }
      // console.log(event);

      this.CheckTimeOutDashboard();
    },
    // تابع تولید عدد رندوم
    randomNumber: function () {
      return Math.floor(Math.random() * (10 - 1 + 1)) + 1;
    },
    // تعریف یک شنوده برای کلیدهای فشرده شده
    keyListener: function (e) {
      var keyReserve = ["n", "د", "c", "ز", "s", "س", "e", "ث", "d", "ی", "F3"];
      var keyF = ["F3", "F4"];
      // تعریف رویداد دریافت کلید فشرده شده
      BusEvent.$emit("keyPressValue", {
        key: e.key,
        altKey: e.altKey,
        ctrlKey: e.ctrlKey,
        shiftKey: e.shiftKey,
      });
      //
      // console.log({
      //   key: e.key,
      //   altKey: e.altKey,
      //   ctrlKey: e.ctrlKey,
      //   shiftKey: e.shiftKey,
      // });

      // لغو عملکرد پیش فرض کلیدها در صورتی که در لیست رزرو شده ها بودند
      if (e.altKey && keyReserve.indexOf(e.key) != -1) {
        e.preventDefault(true);
        e.stopPropagation(true);
      }
      if (keyF.indexOf(e.key) != -1) {
        e.preventDefault(true);
        e.stopPropagation(true);
      }
    },
    // رویداد باز شدن پنجره جدید
    async ChangeTabActive(tabID) {
      // بررسی وضعیت توکن و فراخوانی اطلاعات
      if (await this.$store.dispatch("CheckToken")) {
        this.tabActive.tabID = tabID;
      } else {
        // توکن کاربر تایید نشد . انتقال به صفحه لاگین
        newRoutes.push("Login");
      }
    },
    // تابع بازیابی کل اطلاعات مورد نیاز از سرور
    async LoadAllData(year = 0) {
      // بررسی وضعیت اعتبار توکن کاربر
      if (await this.$store.dispatch("CheckToken")) {
        // دریافت اطلاعات کاربر جاری
        let userData = await this.$store.getters.getUserData;
        // let NUserCode = userData.NUserCode; // کد کاربری
        let token = userData.token; // توکن کاربر

        this.ShowStatusApplication("Get Active Date ...");
        // دریافت تاریخ جاری از سرور
        await this.$store.dispatch("getPersianDateFromServer");
        // متغییر موقت نگهداری سال جاری
        let yearID = 0;

        // بررسی ورودی اطلاعات برای سال
        if (year != 0) {
          // تقاضای نمایش اطلاعات سال مورد نظر کاربر
          yearID = year;
        } else {
          this.ShowStatusApplication("Get Year List ...");
          // دریافت لیست سال های دارای اطلاعات
          await this.$store.dispatch("getListYearDataFromServer", {token});
          yearID = await this.$store.getters.getLastYearData;
          // نمایش اطلاعات سال جاری
          // yearID = await this.$store.getters.getPersianDateValue.PersianYear;
        }

        // تنظیم سال جاری
        this.$store.commit("setYearActive", yearID);

        this.ShowStatusApplication("Get Setting App ...");
        // دریافت تنظیمات نرم افزار
        await this.$store.dispatch("getTbSettingWebAppDataFromServer", {
          token,
        });

        // اگر کاربر به مشاهده نشان ها دسترسی داشت
        // هشدارهای مدیر را نیز مشاهده کند
        if(userData.ShowAlertAdmin == true){
          this.ShowStatusApplication("Get Alert Admin ...");
          // دریافت هشدارهای مدیر
          await this.$store.dispatch("getTbAlertAdminData", {token});
        }

        this.ShowStatusApplication("Get Users Info ...");
        // دریافت لیست کاربران
        await this.$store.dispatch("getListTbUsersInfoFromServer", {token});

        this.ShowStatusApplication("Get Doc Info ...");
        // دریافت لیست اسناد
        await this.$store.dispatch("getListTbDocInfoFromServer", {
          yearID,
          token,
        });

        this.ShowStatusApplication("Get Base Acc Data ...");
        // دریافت لیست حساب ها
        await this.$store.dispatch("getTbBaseAccDataFromSever", {
          yearID,
          token,
        });

        // دریافت لیست حساب ها
        await this.$store.dispatch("getAllTbBaseAccDataFromSever", {
          yearID,
          token,
        });

        this.ShowStatusApplication("Get Person Data ...");
        // دریافت لیست طرف حساب ها
        await this.$store.dispatch("getTbPersonDataFromSever", {token});

        this.ShowStatusApplication("Get Base Use Place Data ...");
        // دریافت لیست مراکز هزینه
        await this.$store.dispatch("getTbBaseUsePlaceDataFromSever", {token});

        this.ShowStatusApplication("Get Base Agreement Data ...");
        // دریافت لیست قراردادها
        await this.$store.dispatch("getTbBaseAgreementDataFromSever", {token});

        this.ShowStatusApplication("Get Base Doc Descs Data ...");
        // دریافت لیست شرح سندها
        await this.$store.dispatch("getTbBaseDocDescsDataFromSever", {token});

        this.ShowStatusApplication("Get Resource Data ...");
        // دریافت لیست کلیه سطوح دسترسی موجود در نرم افزار
        await this.$store.dispatch("getTbObjectsFromSever", {token});

        this.ShowStatusApplication("Get Resource Access User Data ...");
        // دریافت لیست دسترسی های کاربر لاگین کرده از سرور
        let LocalResourceAccessLoginUser = await this.$store.dispatch(
          "getResourceAccessUserFromServer",{ token });
        // ذخیره لیست دسترسی های کاربر لاگین کرده جهت استفاده در سایر فرم ها
        this.$store.commit("setTbUserObjects", LocalResourceAccessLoginUser);

        this.ShowStatusApplication("Get Base Acc Desc Data ...");
        // دریافت لیست شرح حساب ها - شرح ردیف ها
        await this.$store.dispatch("getTbBaseAccDescDataFromSever", {token});

        this.ShowStatusApplication("Get Base Org Data ...");
        // دریافت لیست سازمان ها
        await this.$store.dispatch("getTbBaseOrgDataFromSever", {token});

        this.ShowStatusApplication("Get Base Doc Type Data ...");
        // دریافت لیست انواع سند
        await this.$store.dispatch("getTbBaseDocTypeDataFromSever", {token});

        this.ShowStatusApplication("Get Base Bank Data ...");
        // دریافت لیست بانک ها
        await this.$store.dispatch("getTbBaseBankDataFromSever", {token});

        this.ShowStatusApplication(
          "Get Data Complate . It's OKy .",
          "343a40",
          2000
        );
      } else {
        // توکن کاربر تایید نشد . انتقال به صفحه لاگین
        newRoutes.push("Login");
      }
    }, // LoadAllData

    // متد نمایش وضعیت فعالیت نرم افزار
    ShowStatusApplication(notText, color = "343a40", timeOut = 1500) {
      this.$store.dispatch("statusApplication", {
        notText: notText,
        color: color,
        timeOut: timeOut,
      });
    },
  },
  mounted() {
    if (this.$store.getters.getcanAddListenerHotKey == true) {
      // فعال سازی شنوده در داکیومنت
      setTimeout(() => {
        document.addEventListener("keydown", this.keyListener, false);
        this.$store.commit("setcanAddListenerHotKey", false);
      }, 500);
    }
    this.$el.addEventListener("click", this.onClick);
    // مانت کردن پرونده جاری با ویندوز
    // جهت مدیریت هشدارهای مدیر
    // مورد استفاده در تابع جاوااسکریپت صفحه index.html
    window.AlertAdmin = this;
  },
  // در لحظه ایجاد کامپاننت اجرا می شود
  async created() {
    // // بررسی وضعیت توکن و فراخوانی اطلاعات
    // if (await this.$store.dispatch("CheckToken")) {
    // تعریف رویداد تغییر تب فعال
    BusEvent.$on("ChangeTabActive", this.ChangeTabActive);
    // تعریف رویداد فراخوانی تابع بازیابی کل اطلاعات از سایر کامپاننت ها
    // در لحظه تغییر سال جاری کاربرد دارد
    BusEvent.$on("LoadAllData", this.LoadAllData);
    // فراخوانی تابع بازیابی کل اطلاعات مورد نیاز
    this.LoadAllData();
    // دریافت لیست اسناد ذخیره شده در لوکال محلی
    await this.$store.dispatch("getAccDocDataFromLocalData");
    // تنظیم نمایش کامپاننت ها
    this.setShowComponents(true);
    // } else {
    //   // توکن کاربر تایید نشد . انتقال به صفحه لاگین
    //   newRoutes.push("Login");
    // }
    // فراخوانی تابع کنترل مدت عدم فعالیت کاربر در میزکار
    this.CheckTimeOutDashboard();
  },
  beforeDestroy() {
    // حذف رویداد تغییر تب فعال
    // BusEvent.$off('ChangeTabActive', this.ChangeTabActive);
    // حذف شنونده از داکیومنت در پایان کار کامپاننت
    if (document.removeEventListener) {
      // For all major browsers, except IE 8 and earlier
      document.removeEventListener("keydown", this.keyListener, false);
      this.$store.commit("setcanAddListenerHotKey", true);
    } else if (document.detachEvent) {
      // For IE 8 and earlier versions
      document.detachEvent("keydown", this.keyListener);
      this.$store.commit("setcanAddListenerHotKey", true);
    } else {
      alert("عدم حذف شنونده صفحه کلید !!");
    }
    // خاموش کردن رویداد تغییر تب فعال
    BusEvent.$off("ChangeTabActive", this.ChangeTabActive);
    // خاموش کردن رویداد بازیابی کل اطلاعات
    BusEvent.$off("LoadAllData", this.LoadAllData);

    this.$el.removeEventListener("click", this.onClick);
  },
  // beforeRouteLeave (to, from, next) {
  //   قبل از تغییر روت اجرا می شود
  //   console.log('AdminPanel to: ----------');
  //   console.log(to);
  //   console.log('AdminPanel from: ----------');
  //   console.log(from);
  //   next();
  // }
};
</script>



// WEBPACK FOOTER //
// src/pages/AdminPanel/AdminPanel.vue